import { create } from 'zustand'

type AppConfigState = {
  paidFeatureActive: boolean;
  clearAppConfig: () => void;
  setPaidFeature: (activeState: boolean) => void;
}

export const useAppConfigStore = create<AppConfigState>()((set) => ({
  paidFeatureActive: false,
  clearAppConfig: () => set({
    paidFeatureActive: false
  }),
  setPaidFeature: (activeState: boolean) => set({
    paidFeatureActive: activeState
  })
}))